import React, { Component } from "react";
import {
    Badge,
    Nav,
    NavLink,
    NavItem,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Card,
    CardHeader,
} from "reactstrap"; // DropdownItem, DropdownMenu, DropdownToggle
import PropTypes from "prop-types";

import { AppNavbarBrand, AppSidebarToggler } from "@coreui/react"; //AppHeaderDropdown

import logo from "../../assets/img/brand/logo-Darsur-white.png";
import sygnet from "../../assets/img/brand/LogoMobile.png";

import { CartContext } from "../../components/ParadigmaCartProvider";
import ParadigmaSearch from "../../components/ParadigmaSearch";
import { LoginContext } from "../../components/ParadigmaLoginProvider";
import Login from "../../views/Login";

import api from "../../api/api.js";
import apifunctions from "../../api/functions.js";
import axios from "axios";
import { CompareContext } from "../../components/CompareProvider/CompareProvider.js";
import CartIconMenu from "../../views/Cart/CartIconMenu.js";
import "./styles.scss";

class DefaultHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginOpen: false,
            profileMenuOpen: false,
            isMobile: window.innerWidth <= 1153,
            isMobileImage: false,
        };
        this.handleResize = this.handleResize.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
    }
    static propTypes = {
        children: PropTypes.node,
        Configuracion: PropTypes.object,
    };

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize() {
        this.setState({
            isMobile: window.innerWidth <= 1153,
            isMobileImage: false,
        });
    }

    toggleMenu() {
        this.setState((prevState) => ({
            menuOpen: !prevState.menuOpen,
        }));
    }

    handleClick(evt) {
        evt.preventDefault();
        if (apifunctions.isLogged()) {
            let headers = apifunctions.headers();
            let today = new Date();
            let day = today.getDate();
            let month = today.getMonth() + 1;
            let year = today.getFullYear();

            axios(
                {
                    url: api.api.exportPrecios,
                    method: "GET",
                    responseType: "blob",
                    headers: headers.headers,
                },
                headers
            ).then((response) => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `lista_precios_darsur_${day}-${month}-${year}.xlsx`
                );
                document.body.appendChild(link);
                link.click();
            });
        }
    }

    // downloadListaPrecios(){
    // 	if(apifunctions.isLogged()){
    // 		let headers = apifunctions.headers();
    // 		axios.get(api.api.listadepreciosfichero, headers).then(
    // 			response => {
    // 				window.open(api.api.downloadlistadepreciosfichero.replace('@@',response.data.url));
    // 			}
    // 		).catch(
    // 			err => {
    // 				console.log(err);
    // 			}
    // 		);
    // 	}
    // }
    render() {
        const { loginOpen, profileMenuOpen, isMobile, isMobileImage } =
            this.state;
        const { children, Configuracion, ...attributes } = this.props;
        let username = localStorage.getItem("displayname")
            ? localStorage.getItem("displayname")
            : "";
        let nombre_usuario = localStorage.getItem("nombre_usuario")
            ? localStorage.getItem("nombre_usuario")
            : "";
        let isLogged = apifunctions.isLogged() == true;
        return (
            <React.Fragment>
                <a
                    className={` ${
                        isMobileImage
                            ? "d-none"
                            : "mt-lg-0 navbar-brand-darsur d-flex justify-content-center align-items-center"
                    }`}
                    href="/#/"
                >
                    <img
                        src={logo}
                        alt="SIGE ECOMMERCE"
                        className="navbar-brand-full"
                        width="auto"
                        height="40px"
                    />
                </a>

                <ParadigmaSearch
                    searchStr={this.props.searchStr}
                    updateSearchStr={(v) => this.props.updateSearchStr(v)}
                    className={isMobile ? "navbar-collapsed" : ""}
                    hyperlink
                />

                <Nav
                    className={`mx-auto ml-md-auto justify-content-center navbar ${
                        isMobile ? "navbar-collapsed" : ""
                    }`}
                    navbar
                >
                    <LoginContext.Consumer>
                        {({ logged, logout }) => {
                            if (logged) {
                                return (
                                    <React.Fragment>
                                        <Dropdown
                                            tag={"li"}
                                            className="header-login-menu"
                                            isOpen={profileMenuOpen}
                                            toggle={() =>
                                                this.setState({
                                                    profileMenuOpen:
                                                        !profileMenuOpen,
                                                })
                                            }
                                        >
                                            <DropdownToggle
                                                className="nav-link"
                                                tag="a"
                                            >
                                                <h6 className="d-flex align-items-center c-white">
                                                    <span
                                                        style={{
                                                            verticalAlign:
                                                                "middle",
                                                        }}
                                                    >
                                                        {username &&
                                                        username !==
                                                            "ventas3@darsur.com.ar" &&
                                                        nombre_usuario &&
                                                        nombre_usuario.length >
                                                            0
                                                            ? nombre_usuario
                                                            : username &&
                                                              username.length >
                                                                  0
                                                            ? username
                                                            : "Usuario Invitado"}

                                                        {/* {
																username && username.length > 0 && username.indexOf("ventas3@darsur.com.ar") == -1 ?
																	username
																:
																"Usuario Invitado"
															} */}
                                                    </span>
                                                    <i
                                                        style={{
                                                            fontSize: "30px",
                                                            color: "#fff",
                                                        }}
                                                        className="fa cui-user"
                                                    ></i>
                                                </h6>
                                                <Badge
                                                    pill
                                                    color="danger"
                                                ></Badge>
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                {username != "" &&
                                                    username.indexOf(
                                                        "ventas3@darsur.com.ar"
                                                    ) == -1 && (
                                                        <React.Fragment>
                                                            <DropdownItem href="#/perfil">
                                                                <i className="fa fa-user"></i>
                                                                Perfil
                                                            </DropdownItem>
                                                            {/* <DropdownItem href={api.api.exportPrecios} target="_blank"> */}
                                                            <DropdownItem
                                                                onClick={
                                                                    this
                                                                        .handleClick
                                                                }
                                                                target="_blank"
                                                            >
                                                                <i
                                                                    className="fa fa-list-alt"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                Descargar Lista
                                                                de Precios
                                                            </DropdownItem>
                                                            <DropdownItem href="#/pedidos">
                                                                <i
                                                                    className="fa fa-inbox"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                Mis Pedidos
                                                            </DropdownItem>
                                                            {/* <DropdownItem href="#/payments">
																<i className="fa fa-credit-card" aria-hidden="true"></i>
																Mis Compras
															</DropdownItem> */}
                                                            <DropdownItem href="#/resumencuenta">
                                                                <i
                                                                    className="fa fa-credit-card"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                Cuenta Corriente
                                                            </DropdownItem>
                                                        </React.Fragment>
                                                    )}
                                                <DropdownItem
                                                    onClick={() =>
                                                        this.setState(
                                                            {
                                                                loginOpen: false,
                                                            },
                                                            () => logout()
                                                        )
                                                    }
                                                >
                                                    <i className="fa fa-sign-out"></i>
                                                    Salir
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                        <React.Fragment>
                                            <NavItem className="header-login-menu">
                                                <NavLink>
                                                    <CartIconMenu />
                                                </NavLink>
                                            </NavItem>
                                        </React.Fragment>
                                        <CompareContext>
                                            {({ itemsToCompare }) => {
                                                return (
                                                    <React.Fragment>
                                                        <NavItem className="header-login-menu">
                                                            <NavLink
                                                                href={
                                                                    "#compareList"
                                                                }
                                                            >
                                                                <i
                                                                    style={{
                                                                        fontSize:
                                                                            "30px",
                                                                        fontWeight:
                                                                            "100",
                                                                    }}
                                                                    className="fa fa-exchange c-white"
                                                                ></i>
                                                                {itemsToCompare &&
                                                                itemsToCompare.length ? (
                                                                    <Badge
                                                                        pill
                                                                        color="warning"
                                                                    >
                                                                        {
                                                                            itemsToCompare.length
                                                                        }
                                                                    </Badge>
                                                                ) : null}
                                                            </NavLink>
                                                        </NavItem>
                                                    </React.Fragment>
                                                );
                                            }}
                                        </CompareContext>
                                    </React.Fragment>
                                );
                            } else
                                return (
                                    <React.Fragment>
                                        <NavItem>
                                            <a
                                                className="btn bg-white btn-sa text-blue-500"
                                                href={"#"}
                                                onClick={() =>
                                                    this.setState({
                                                        loginOpen: true,
                                                    })
                                                }
                                            >
                                                <i className="fa fa-user"></i>{" "}
                                                Ingresar
                                                <Badge
                                                    pill
                                                    color="danger"
                                                ></Badge>
                                            </a>
                                        </NavItem>
                                    </React.Fragment>
                                );
                        }}
                    </LoginContext.Consumer>
                </Nav>
                <i
                    className={`fa fa-bars menu-icon ${isMobile ? "show" : ""}`}
                    onClick={() =>
                        this.setState({
                            isMobile: !isMobile,
                            isMobileImage: !isMobileImage,
                        })
                    }
                ></i>

                <Login
                    open={loginOpen}
                    onClose={() => this.setState({ loginOpen: false })}
                />
            </React.Fragment>
        );
    }
}

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js